<template>
   <div>
      <div v-for="error in errors" :key="errors.indexOf(error)">
         <v-alert
            v-if="!isEmpty(error)" 
            :type="error.err_type" 
            dismissible 
            outlined 
            text 
            class="mb-4"
         >
            <span v-html="formatText(error.err_value_text)"></span>
         </v-alert>
      </div> 
   </div> 
</template>

<script>
   export default {
      props: {
         errors: Array
      },

      methods: {

         isEmpty(obj) {
            if ( obj===null) {
               return true
            } else {
               return Object.keys(obj).length === 0;
            }
         },

         formatText: function(string) {
            var ret = '';
            if ( typeof string != "undefined" ) {
               ret = string.replace(/\n/g,'<br/>');
            }
            return ret;
         },
      },

      data: () => {
         return {
         }
      }
   }
</script>